/**
 * FormHelper - parses the error response object from the API
 * @deprecated DO NOT REUSE THIS - IT IS DEPRECATED
 */
angular.module('qkr').factory('FormHelper', ['messageService', '$window', 'appConfig', 'gettextCatalog', function(messageService, $window, appConfig, gettextCatalog) {
    return function(scope) {
        const SESSION_INVALID = 302;
        const BAD_REQUEST = 400;
        const FORBIDDEN = 403;
        const API_KEY_INVALID = 401;
        const OBJECT_NOT_FOUND = 404;
        const OPERATION_NOT_ALLOWED = 405;
        const SESSION_EXPIRED = 419;
        const SYSTEM = 500;
        const SERVICE_UNAVAILABLE = 503;

        const SUCCESS = 200;
       
        function parseFieldErrors(err) {
            const errors = {};

            if (err.data.errors) {
                angular.forEach(err.data.errors, (value) => {
                    errors[value.field] = value.reason;
                });
            }
            return errors;
        }

        /**
         *  @deprecated DO NOT REUSE THIS - IT IS DEPRECATED
         */
        this.handleResponse = function(response) {
            // Reset the errors object (this will remove any display errors that are bound in the UI)
            scope.errors = {};

            this.response = response;
            this.responseStatus = response.status * 1;

            switch (this.responseStatus) {
                case SESSION_INVALID:
                    $window.location.href = appConfig.logoutUrl + '?timeout=true';
                    break;
                case BAD_REQUEST:
                    if (response.data.exception === 'Validation') {
                        this.fieldErrors = parseFieldErrors(response);
                        scope.errors = this.fieldErrors;
                    } else if (!response.data.message) {
                    	// The exception is the message validation
                    	// MessageService.error( response.data.exception );
                    } else { 
                    	// MessageService.error( error(response).message );
                    }
                    break;

                case API_KEY_INVALID:
                case SESSION_EXPIRED:

                    $window.location.href = appConfig.logoutUrl + '?timeout=true';

                    break;

                case OPERATION_NOT_ALLOWED:
                case OBJECT_NOT_FOUND:
                case SERVICE_UNAVAILABLE:

                    // Scope.error = error(response).message
                   // MessageService.error( error(response).message );

                    break;

                case SYSTEM:

                    // Scope.error = "An unexpected error has occurred";
                   // MessageService.error("An unexpected error has occurred");
                    break;
                    
                case FORBIDDEN:    
                	 // MessageService.error("An unexpected error has occurred, request forbidden");
                	 break;

                default:

                    // Response only carries error status so if we get here we assume a SUCCESS
                    this.responseStatus = SUCCESS;

                    break;
            }
            this.success = this.responseStatus === SUCCESS;

            return this;
        };

        this.handleError = function(reason) {
            messageService.log('handleError', reason);

            if (reason.data && reason.data.message) {
                messageService.error(reason.data.message);
            } else if (reason.message) {
                messageService.error(reason.message);
            } else if (reason.exception) {
                messageService.error(reason.exception);
            } else {
                messageService.error(gettextCatalog.getString('An unexpected error has occurred'));
            }

            scope.saving = false;
        };

        this.isSuccess = function() {
            return this.responseStatus === SUCCESS;
        };

        this.statusCode = function() {
            return this.responseStatus;
        };

        this.errors = function() {
            return this.fieldErrors;
        };
    };
}]);



// WEBPACK FOOTER //
// ./src/services/formHelper.js